export default {
  // Common
  'common.cancel': '取消',
  'common.ok': '確定',
  
  'pages.layouts.userLayout.title': 'Ant Design 是西湖區最具影響力的 Web 設計規範',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage': '錯誤的用戶名和密碼(admin/ant.design)',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.username.placeholder': '用戶名: admin or user',
  'pages.login.username.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '密碼: ant.design',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '獲取驗證碼',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.login.rememberMe': '自動登錄',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.login.submit': '登錄',
  'pages.login.loginWith': '其他登錄方式 :',
  'pages.login.registerAccount': '註冊賬戶',
  'pages.welcome.link': '歡迎使用',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.dashboard.text': '無縫接入門店管理生態，提供遠程積分管理解決方案。',
  'pages.dashboard.management.title': '總部管理',
  'pages.dashboard.headquartersManagement': '总部管理',
  'pages.dashboard.storeTitle': '這是一個標題',
  'pages.dashboard.store.name': '門店{number}',
  'pages.dashboard.orders': '發票',
  'pages.dashboard.members': '會員',
  'pages.dashboard.cards': '禮品卡',
  'pages.dashboard.coupons': '折扣券',
  'pages.dashboard.tooltip.orders': '發票列表',
  'pages.dashboard.tooltip.members': '會員列表',
  'pages.dashboard.tooltip.cards': '禮品卡管理',
  'pages.dashboard.tooltip.coupons': '折扣券管理',
  'pages.dashboard.store.online': '已营业',
  'pages.dashboard.store.offline': '未营业',
  'pages.dashboard.store.points': '積分',
  'pages.dashboard.store.cardValue': '卡值',
  'pages.dashboard.headquartersVoucher': '總部代金券',
  'pages.dashboard.headquartersVoucher.title': '創建總部代金券',
  'pages.dashboard.tooltip.qrcode': '顯示會員註冊二維碼',
  'pages.dashboard.qrcode.title': '會員註冊二維碼',
  'pages.dashboard.qrcode.download': '下載二維碼',
  'pages.dashboard.qrcode.close': '關閉',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',

  'pages.invoiceList.title': '發票列表',
  'pages.invoiceList.table.invoiceNumber': '發票號',
  'pages.invoiceList.search.invoiceNumber.placeholder': '請輸入發票號',
  'pages.invoiceList.search.invoiceNumber': '發票號',
  'pages.invoiceList.search.customerInfoType': '客戶信息類型',
  'pages.invoiceList.search.customerInfo': '客戶信息',
  'pages.invoiceList.search.reset': '重置',
  'pages.invoiceList.search.submit': '查詢',
  'pages.invoiceList.search.refresh': '刷新',
  'pages.invoiceList.customerInfo': '客戶信息',
  'pages.invoiceList.search.customerInfoType.phone': '手機',
  'pages.invoiceList.search.customerInfoType.name': '名字',
  'pages.invoiceList.search.customerInfoType.memberId': '會員ID',
  'pages.invoiceList.search.customerInfo.placeholder': '請輸入',
  'pages.store.title': '首頁',
  'pages.orderList.title': '發票列表',
  'pages.orderList.invoiceNo': '發票號',
  'pages.orderList.invoiceTime': '開票時間',
  'pages.orderList.totalAmount': '總金額',
  'pages.orderList.customerName': '客戶名稱',
  'pages.orderList.customerInfo': '客戶信息',
  'pages.orderList.customerInfo.phone': '手機',
  'pages.orderList.customerInfo.name': '名字',
  'pages.orderList.customerInfo.memberId': '會員ID',
  'pages.orderList.status': '狀態',
  'pages.orderList.status.pending': '待處理',
  'pages.orderList.status.completed': '已完成',
  'pages.orderList.status.cancelled': '已取消',
  'pages.orderList.status.paid': '已支付',
  'pages.orderList.status.refunded': '退款',
  'pages.orderList.status.partiallyRefunded': '部分退款',
  'pages.orderList.actions': '操作',
  'pages.orderList.actions.details': '明細',
  'pages.orderList.search.invoiceNo.placeholder': '請輸入發票號',
  'pages.orderList.search.customerInfo.placeholder': '請輸入',
  'pages.orderList.search.reset': '重置',
  'pages.orderList.search.submit': '查詢',
  'pages.orderList.search.refresh': '刷新',
  'pages.memberList.title': '會員列表',
  'pages.memberList.name': '名字',
  'pages.memberList.search.info.placeholder': '請輸入',
  'pages.memberList.create': '創建',
  'pages.memberList.memberId': '會員編號',
  'pages.memberList.registerTime': '註冊時間',
  'pages.memberList.phone': '聯繫電話',
  'pages.memberList.email': '郵箱',
  'pages.memberList.points': '當前剩餘積分',
  'pages.memberList.actions': '操作',
  'pages.memberList.actions.details': '詳情',
  'pages.memberList.status': '狀態',
  'pages.memberList.status.active': '激活',
  'pages.memberList.status.inactive': '未激活',
  'pages.memberList.search.memberId.placeholder': '請輸入會員ID',
  'pages.memberList.search.info': '用戶信息',
  'pages.memberList.search.info.phone': '手機',
  'pages.memberList.search.info.name': '名字',
  'pages.memberList.search.info.memberId': '會員ID',
  'pages.memberList.search.info.email': '郵箱',
  'pages.memberList.search.reset': '重置',
  'pages.memberList.search.submit': '查詢',
  'pages.memberList.search.refresh': '刷新',
  'pages.memberDetails.status.active': '已啟用',
  'pages.memberDetails.status.inactive': '未啟用',
  'store.giftCard.list.title': '禮品卡列表',
  'store.giftCard.list.search.cardId': '禮品卡編號',
  'store.giftCard.list.search.phone': '手機',
  'store.giftCard.list.search.email': '郵箱',
  'store.giftCard.list.search.status': '狀態',
  'store.giftCard.list.search.status.active': '激活',
  'store.giftCard.list.search.status.inactive': '未激活',
  'store.giftCard.list.table.cardId': '禮品卡編號',
  'store.giftCard.list.table.balance': '當前剩餘金額',
  'store.giftCard.list.table.status': '狀態',
  'store.giftCard.list.table.createTime': '創建時間',
  'store.giftCard.list.table.actions': '操作',
  'store.giftCard.list.table.view': '詳情',
  'store.giftCard.list.create': '創建',
  'store.giftCard.list.cardId': '禮品卡編號',
  'store.giftCard.list.createTime': '創建時間',
  'store.giftCard.list.phone': '聯繫電話',
  'store.giftCard.list.email': '郵箱',
  'store.giftCard.list.balance': '當前剩餘金額',
  'store.giftCard.list.actions': '操作',
  'store.giftCard.list.actions.details': '詳情',
  'store.giftCard.list.status': '狀態',
  'store.giftCard.list.status.active': '激活',
  'store.giftCard.list.status.inactive': '未激活',
  'store.giftCard.list.card.number': '禮品卡號',
  'store.giftCard.list.action': '操作',
  'store.giftCard.list.search.cardId.placeholder': '請輸入禮品卡編號',
  'store.giftCard.list.search.info': '臨時用戶信息',
  'store.giftCard.list.search.info.phone': '手機',
  'store.giftCard.list.search.info.name': '名字',
  'store.giftCard.list.search.info.email': '郵箱',
  'store.giftCard.list.search.reset': '重置',
  'store.giftCard.list.search.submit': '查詢',
  'store.giftCard.list.search.refresh': '刷新',
  'store.giftCard.list.detail': '詳情',
  'pages.voucherList.title': '代金券列表',
  'pages.voucherList.voucherId': '代金券編號',
  'pages.voucherList.voucherName': '代金券名稱',
  'pages.voucherList.startDate': '生效日期',
  'pages.voucherList.createTime': '創建時間',
  'pages.voucherList.phone': '聯繫電話',
  'pages.voucherList.email': '郵箱',
  'pages.voucherList.amount': '金額',
  'pages.voucherList.minPurchase': '最低消費',
  'pages.voucherList.expiryDate': '有效期至',
  'pages.voucherList.action': '操作',
  'pages.voucherList.actions': '操作',
  'pages.voucherList.detail': '詳情',
  'pages.voucherList.actions.details': '詳情',
  'pages.voucherList.status': '狀態',
  'pages.voucherList.status.active': '激活',
  'pages.voucherList.status.inactive': '未激活',
  'pages.voucherList.status.expired': '已過期',
  'pages.voucherList.status.used': '已使用',
  'pages.voucherList.create': '創建代金券',
  'pages.voucherList.createVirtual': '創建虛擬代金券',
  'pages.voucherList.createPhysical': '創建實體代金券',
  'pages.voucherList.downloadPhysical': '下載實體代金券',
  'pages.voucherList.physicalVoucherNumber': '實體代金券編號',
  'pages.voucherList.voucherNumber': '代金券編號',
  'pages.voucherList.distributionStore': '派發門店',
  'pages.voucherList.contactValue': '聯繫信息',
  'pages.voucherList.all': '全部',
  'pages.voucherList.noStore': '未找到可訪問的門店',
  'pages.voucherList.physical.quantity': '數量',
  'pages.voucherList.physical.batch': '創建批次',
  'pages.voucherList.physical.allBatches': '全部批次',
  'pages.voucherList.physical.loadError': '載入實體代金券表單失敗',
  'pages.voucherList.physical.createSuccess': '成功創建 {count} 張實體代金券',
  'pages.voucherList.physical.createError': '創建實體代金券失敗',
  'pages.voucherList.physical.batchLoadError': '載入實體代金券批次失敗',
  'pages.voucherList.physical.downloadError': '下載實體代金券失敗',
  'pages.voucherList.search.voucherId.placeholder': '請輸入代金券編號',
  'pages.voucherList.search.info': '臨時用戶信息',
  'pages.voucherList.search.info.phone': '手機',
  'pages.voucherList.search.info.name': '名字',
  'pages.voucherList.search.info.email': '郵箱',
  'pages.voucherList.search.reset': '重置',
  'pages.voucherList.search.submit': '查詢',
  'pages.voucherList.search.refresh': '刷新',
  'pages.voucherList.modal.title': '創建代金券',
  'pages.voucherList.modal.bulkSend': '群發',
  'pages.voucherList.modal.singleSend': '單獨發送',
  'pages.voucherList.modal.template': '代金券模板',
  'pages.voucherList.modal.templateName': '模板名稱',
  'pages.voucherList.modal.template.placeholder': '請選擇代金券模板',
  'pages.voucherList.modal.selectTemplate': '選擇代金券模板',
  'pages.voucherList.modal.selectMemberLevel': '選擇會員等級',
  'pages.voucherList.modal.memberList': '會員列表',
  'pages.voucherList.modal.memberLevelList': '會員等級列表',
  'pages.voucherList.modal.memberLevelName': '會員等級名稱',
  'pages.voucherList.modal.memberCount': '用戶數量',
  'pages.voucherList.modal.memberCountText': '{count} 位用戶',
  'pages.voucherList.modal.selectMembers': '選擇會員',
  'pages.voucherList.modal.selectedCount': '已選擇 {count} 位會員',
  'pages.voucherList.modal.searchMember': '搜索會員',
  'pages.voucherList.modal.sendList': '發送列表',
  'pages.voucherList.modal.addToList': '添加',
  'pages.voucherList.modal.removeFromList': '移除',
  'pages.voucherList.modal.submit': '提交',
  'pages.voucherList.modal.cancel': '取消',
  'pages.voucherList.modal.noHeadOffice': '未找到總部信息',
  'pages.voucherList.modal.fetchTemplatesFailed': '獲取代金券模板失敗',
  'pages.voucherList.modal.fetchMembersFailed': '獲取會員列表失敗',
  'pages.voucherList.modal.searchFailed': '搜索會員失敗',
  'pages.voucherList.modal.alreadyInList': '該會員已在發送列表中',
  'pages.voucherList.modal.addSuccess': '添加成功',
  'pages.voucherList.modal.removeSuccess': '移除成功',
  'pages.voucherList.modal.submitSuccess': '提交成功',
  'pages.voucherList.modal.template.required': '請選擇代金券模板',
  'pages.voucherList.modal.memberLevel.required': '請選擇會員等級',
  'pages.voucherList.modal.members.required': '請添加要發送的會員',
  'pages.voucherList.modal.creating': '正在創建代金券...',
  'pages.voucherList.modal.createSuccess': '成功創建 {count} 個代金券，CSV文件已下載',
  'pages.voucherList.modal.createFailed': '創建代金券失敗',
  'pages.voucherList.modal.emptyList': '暫無數據',
  // Voucher Details
  'pages.store.voucherDetails.send.phone.label': '手機號碼',
  'pages.store.voucherDetails.send.email.label': '郵箱地址',
  'pages.store.voucherDetails.send.phone.placeholder': '請輸入手機號碼（如：0412345678）',
  'pages.store.voucherDetails.send.email.placeholder': '請輸入郵箱地址',
  'pages.store.voucherDetails.send.phone.required': '請輸入手機號碼',
  'pages.store.voucherDetails.send.email.required': '請輸入郵箱地址',
  'pages.store.voucherDetails.send.phone.invalid': '請輸入正確的手機號碼（04開頭10位數字）',
  'pages.store.voucherDetails.send.email.invalid': '請輸入正確的郵箱地址',
  'pages.store.voucherDetails.send.sms.success': '短信發送成功',
  'pages.store.voucherDetails.send.sms.failed': '短信發送失敗',
  'pages.store.voucherDetails.send.email.success': '郵件發送成功',
  'pages.store.voucherDetails.send.email.failed': '郵件發送失敗',
  'pages.orderDetails.invoiceInfo': '發票信息',
  'pages.orderDetails.invoiceNumber': '發票編號',
  'pages.orderDetails.status': '狀態',
  'pages.orderDetails.status.paid': '已支付',
  'pages.orderDetails.status.unpaid': '未支付',
  'pages.orderDetails.invoiceTime': '開票時間',
  'pages.orderDetails.pointsEarned': '本次增加積分',
  'pages.orderDetails.remarks': '備註',
  'pages.orderDetails.voucherNumber': '代金券編號',
  'pages.orderDetails.noRemarks': '無',
  'pages.orderDetails.afterTransaction': '消費後',
  'pages.orderDetails.items': '購買商品',
  'pages.orderDetails.productAmount': '本次商品消費',
  'pages.orderDetails.consumption': '商品消費',
  'pages.orderDetails.actualPayment': '實際消費',
  'pages.orderDetails.serviceFee': '手續費',
  'pages.orderDetails.memberDiscount': '會員優惠',
  'pages.orderDetails.memberPoints': '會員積分抵扣',
  'pages.orderDetails.giftCard': '禮品卡支付',
  'pages.orderDetails.voucherRedemption': '代金券抵扣',
  'pages.orderDetails.total': '合計',
  'pages.orderDetails.customer': '客戶信息',
  'pages.orderDetails.customerName': '姓名',
  'pages.orderDetails.customerBalance': '積分餘額',
  'pages.orderDetails.email': '郵箱',
  'pages.orderDetails.phone': '手機號',
  'pages.orderDetails.viewCustomerDetails': '查看詳情',
  'pages.orderDetails.card': '儲值卡信息',
  'pages.orderDetails.cardNumber': '卡號',
  'pages.orderDetails.cardBalance': '餘額',
  'pages.orderDetails.voucher': '代金券信息',
  'pages.orderDetails.voucherCode': '代金券編號',
  'menu.home': '首頁',
  'menu.orders': '發票管理',
  'menu.invoiceList': '發票列表',
  'menu.invoiceDetails': '發票詳情',
  'menu.memberList': '會員列表',
  'menu.giftCardList': '禮品卡列表',
  'menu.voucherList': '折扣券列表',
  'pages.actions': {
    'create': '新建',
    'edit': '編輯',
    'delete': '刪除',
    'view': '查看',
    'search': '搜索',
    'reset': '重置',
    'submit': '提交',
    'cancel': '取消',
    'confirm': '確認',
  },

  'pages.store.memberDetails': {
    'edit.success': '編輯成功',
    'edit.fail': '編輯失敗',
    'edit.submit': '提交',
    'edit.cancel': '取消',
    'edit.title': '信息編輯',
    'member': '會員',
    'memberId': '會員編號',
    'memberLevel': '會員等級',
    'discount': '折扣',
    'points.modify': '積分修改',
    'send.card': '發送會員卡',
    'send.email': '發送至郵箱',
    'send.phone': '發送至手機',
    'edit.info': '信息編輯',
    'basic.info': '基本信息',
    'consumption.record': '消費記錄',
    'points.record': '積分記錄',
    'points.reward': '積分奖励',
    'points.redeem': '積分兌換',
    'points.after': '使用後',
    'points.time': '時間',
    'points.change': '積分變更',
    'points.operation': '操作',
    'points.remark': '备注',
    'modify.points': '修改積分',
    'reset.points': '重置積分',
    'reason': '原因',
    'send.card.success': '發送成功',
    'send.card.fail': '發送失敗',
    'send.card.submit': '提交',
    'send.card.cancel': '取消',
    'send.card.title': '發送會員卡',
    'send.card.member': '會員',
    'send.card.memberId': '會員編號',
    'send.card.points': '積分',
    'send.card.points.modify': '修改',
    'send.card.points.reset': '重置',
    'send.card.points.current': '當前積分',
    'send.card.points.new': '新積分',
    'send.card.points.remark': '备注',
    'send.card.points.operation': '操作',

    'points.type': '類型',
    'points.type.manual': '手動',
    'points.type.transaction': '交易',
    'points.change.record': '積分變更記錄',
    'invoice.number': '發票編號',
    'invoice.amount': '發票金額',
    'invoice.date': '發票日期',
    'please.enter': '請輸入',
    'search': '查詢',
    'reset': '重置',
    'status': '狀態',
    'points': '積分',
    'member.level': '會員等級',
    'phone': '手機',
    'email': '郵箱',
    'registration.time': '註冊時間',
    'last.consumption': '最近消費',
    'name': '姓名',
    'company': '所屬公司',
    'registration.store': '註冊門店',
    'store.manager': '門店管理',
    'store': '門店',
    'action': '操作',
    'detail': '明細',
    'status.active': '已啟用',
    'status.inactive': '未啟用',
    'status.pending_payment': '待支付',
    'status.paid': '已支付',
    'status.refunded': '退款',
    'status.partial_refund': '部分退款',
    'total.points': '累計積分',
    'rewardEnabled': '積分獎勵',
    'rewardEnabled.on': '已啟用',
    'rewardEnabled.off': '已禁用',
  },
  'pages.store.memberDetails.record.date': '記錄日期',
  'pages.store.giftCardDetails': {
    'giftCard': '禮品卡',
    'card.number': '禮品卡號',
    'temp.phone': '臨時發送電話',
    'temp.email': '臨時發送郵箱',
    'register.time': '創建時間',
    'valid.days': '有效期（天）',
    'active.time': '激活時間',
    'expiry.time': '到期時間',
    'company': '所屬公司',
    'registration.store': '創建門店',
    'store.manager': '門店管理',
    'status': '狀態',
    'balance.after': '使用後',
    'balance': '剩餘餘額',
    'balance.record': '餘額變更記錄',
    'record.date': '記錄日期',
    'time': '時間',
    'points': '積分',
    'amount': '金額',
    'before': '使用前',
    'type': '類型',
    'type.consume': '消費',
    'type.activation': '激活',
    'type.refund': '退款',
    'type.manual': '手動',
    'description': '描述',
    'send.card': '發送禮品卡',
    'send.email': '發送至郵箱',
    'send.phone': '發送至手機',
    'edit.info': '信息編輯',
    'registration.time': '創建時間',
    'consumption.record': '消費記錄',
    'balance.change.record': '餘額變更記錄',
    'invoice.number': '發票編號',
    'invoice.date': '發票日期',
    'please.enter': '請輸入',
    'search': '查詢',
    'reset': '重置',
    'store': '門店',
    'action': '操作',
    'detail': '明細',
    'status.active': '激活',
    'status.inactive': '已禁用',
    'status.expired': '已過期',
    'balance.modify': '餘額修改',
    'status.paid': '已支付',
    'status.refunded': '退款',
    'status.partial_refund': '部分退款',
    'balanceChangeRecords': '餘額變更記錄',
    'consumptionRecords': '消費記錄',
    'changeTime': '變更時間',
    'changeAmount': '變更金額',
    'operation': '操作',
    'operator': '操作人',
    'selectDate': '選擇日期',
    'invoice.amount': '禮品卡使用金額',
    'operation.type.recharge': '充值',
    'operation.type.consumption': '消費',
    'operation.type.change': '變更',
    'operation.source.store': '門店',
    'operation.source.website': '網站',
    'send.giftcard': '發送禮品卡',
    'send.to.phone': '發送到手機',
    'send.to.email': '發送到郵箱',
    'send.success': '發送成功',
    'send.error': '發送失敗',
    'balance.modify': '餘額修改',
    'reset.balance': '重置餘額',
    'reason': '原因',
    'balance.amount': '金額',
    'balance.amount.required': '請輸入金額',
    'balance.amount.min': '金額必須大於0',
    'balance.reason': '修改原因',
    'balance.reason.required': '請輸入修改原因',
    'balance.modify.success': '修改成功',
    'balance.modify.error': '修改失敗',
  },
  'pages.store.voucherDetails': {
    'title': '折扣券詳情頁',
    'tempPhone': '臨時發送電話',
    'tempEmail': '臨時發送郵箱',
    'company': '所屬公司',
    'createTime': '創建時間',
    'expireTime': '截至時間',
    'createStore': '創建門店',
    'startTime': '開始時間',
    'Store': '門店',
    'reset': '重置',
    'editInformation': '編輯信息',
    'editStatus': '修改代金券狀態',
    'cancel': '取消',
    'ok': '確定',
    'delete': '刪除',
    'delete.confirm': '確定要刪除這個代金券嗎？',
    'delete.warning': '刪除後無法恢復！',
    'delete.success': '刪除成功',
    'delete.failed': '刪除失敗',
    'enable': '啟用',
    'disable': '禁用',
    'status.update.success': '狀態更新成功',
    'status.update.failed': '狀態更新失敗',
    'storeManager': '門店經理',
    'status': '狀態',
    'amount': '折扣券面額',
    'consumption.records': '使用記錄',
    'consumption.tradeCode': '發票編號',
    'consumption.invoiceDate': '發票日期',
    'consumption.amount': 'Voucher使用金額',
    'consumption.store': '門店',
    'consumption.status': '狀態',
    'consumption.tradeCode.placeholder': '請輸入發票編號',
    'search': '搜索',
    'send.voucher': '發送折扣券',
    'send.to.phone': '發送到手機',
    'send.to.email': '發送到郵箱',
    'send.success': '發送成功',
    'send.error': '發送失敗',
    'balance.modify': '餘額修改',
    'balance.amount': '金額',
    'balance.amount.required': '請輸入金額',
    'balance.amount.min': '金額必須大於0',
    'balance.reason': '修改原因',
    'balance.reason.required': '請輸入修改原因',
    'balance.modify.success': '修改成功',
    'balance.modify.error': '修改失敗',
  },
  'menu.settings': '設置',
  'pages.store.settings': {
    'title': '店鋪設置',
    'basicInfo': '基本信息',
    'storeName': '店鋪名稱',
    'storeName.required': '請輸入店鋪名稱',
    'action': '操作',
    'edit': '卡面編輯',
    'delete': '刪除',
    'giftCardLevel.add': '添加等級',
    'voucherLevel.add': '添加等級',
    'voucherLevelIndex': '等級',
    'voucherLevelName': '等級名稱',
    'defaultBalance': '默認餘額',
    'giftCardLevelDefaultBalance': '默認餘額',
    'giftCardLevelDefaultBalance.required': '請輸入默認餘額',
    'giftcardLevelIndex': '等級',
    'giftcardLevelName': '等級名稱',
    'voucherLevelDefaultBalance': '默認餘額',
    'voucherLevelDefaultBalance.required': '請輸入默認餘額',
    'pointsPerDollar': '每消費1元獲得積分',
    'pointsPerDollar.required': '請輸入每消費1元獲得積分',
    'dollarsPerPoint': '每1元可抵扣積分',
    'dollarsPerPoint.required': '請輸入積分抵扣比例',
    'startDate': '開始日期',
    'startDate.required': '請輸入開始日期',
    'expiryDate': '到期日期',
    'expiryDate.required': '請輸入到期日期',
    'minPurchase': '最低消費',
    'minPurchase.required': '請輸入最低消費',
    'amount': '金額',
    'amount.required': '請輸入金額',
    'memberLevels': '會員等級設置',
    'giftCardLevels': '禮品卡等級設置',
    'voucherLevels': '折扣券等級設置',
    'memberLevel.level': '等級',
    'memberLevel.name': '等級名稱',
    'memberLevel.discountRate': '折扣率',
    'memberLevel.add': '添加等級',
    'memberLevelIndex': '等級',
    'memberLevelName': '等級名稱',
    'memberLevelDiscountRate': '折扣率',
    'save': '保存更改',
  },
  'pages.store.statistics': {
    'title': '通訊統計',
    'headOffice': {
      'overview': '總部通訊使用概覽',
      'emailQuota': '本月可用郵件總量',
      'emailRemaining': '本月剩餘郵件額度',
      'smsQuota': '本月可用短信總量',
      'smsRemaining': '本月剩餘短信額度',
      'emailTrend': '郵件月度使用量趨勢',
      'smsTrend': '短信月度使用量趨勢',
      'historyUsage': '歷史使用量統計',
      'selectDateRange': '選擇日期範圍：',
      'currentYearMonth': '當前年月',
      'last6Months': '最近6個月數據',
      'emailUnit': '封',
      'smsUnit': '條',
      'noData': '暫無數據',
      'loading': '加載中...',
      'downloadExcel': '下載Excel',
      'month': '月份',
      'emailCount': '郵件使用量',
      'smsCount': '短信使用量',
      'emailResourcePackages': '郵件資源包',
      'smsResourcePackages': '短訊資源包',
      'totalQuota': '總配額',
      'used': '已使用',
      'remaining': '剩餘',
      'expireDate': '到期日期',
      'status': '狀態',
      'active': '有效',
      'expired': '已過期',
      'total': '總計',
      'emails': '封郵件',
      'messages': '條短訊',
    },
    'store': {
      'usage': '分店使用量統計',
      'name': '分店名稱',
      'emailUsage': '本月郵件使用量',
      'smsUsage': '本月短信使用量',
      'action': '操作 (最近6個月)',
      'downloadSms': '下載短信記錄',
      'downloadEmail': '下載郵件記錄',
      'noData': '暫無數據',
    },
    'smsCostCalculator': {
      'title': '短訊成本計算器',
      'content': '短訊內容',
      'contentPlaceholder': '輸入您要發送的短訊內容，支援表情符號和換行...',
      'recipients': '發送人數',
      'recipientsPlaceholder': '輸入需要發送的人數',
      'calculate': '計算費用',
      'reset': '重置',
      'segmentCount': '分段數量',
      'segments': '段',
      'costPerMessage': '單條費用',
      'totalCost': '總費用',
      'priceDisclaimer': '價格僅供參考，準確價格以聯繫 POS Supplier 為準',
      'tips': '溫馨提示',
      'tip1': '• 包含中文、表情符號會增加分段數量',
      'tip2': '• 純英文：160字元/條，超出後按153字元分段',
      'tip3': '• 含中文/表情：70字元/條，超出後按67字元分段',
      'tip4': '• 單條短訊價格：$0.18 AUD',
    },
  },
  'pages.actions.operation': '操作',
  'pages.actions.save': '保存',
  'pages.store.settings.voucherLevel.add':'添加',
  'pages.store.settings.giftCardLevel.add':'添加',
  'pages.store.settings.memberLevel.maxLimit': '最多只能設置10個等級',
  'pages.store.settings.save.success': '保存成功',
  'pages.store.settings.save.error': '保存失敗',

  // 員工管理相關
  'pages.staff': {
    'title': '員工管理',
    'add': '添加員工',
    'list.username': '用戶名',
    'list.email': '郵箱',
    'list.role': '角色',
    'list.actions': '操作',
    'list.edit': '編輯',
    'list.delete': '刪除',
    'list.fetchFailed': '獲取員工列表失敗',
    'delete.confirm': '確認刪除',
    'delete.content': '確定要刪除此員工嗎？該操作不可撤銷。',
    'delete.success': '刪除成功',
    'delete.failed': '刪除失敗',
    'add.title': '添加員工',
    'edit.title': '編輯員工',
    'add.success': '添加成功',
    'add.failed': '添加失敗',
    'edit.success': '更新成功',
    'edit.failed': '更新失敗',
    'role.admin': '管理員',
    'role.staff': '員工',
    'tabs.basic': '基本信息',
    'tabs.permissions': '權限設置',
    'form.username': '用戶名',
    'form.username.required': '請輸入用戶名',
    'form.email': '郵箱',
    'form.email.required': '請輸入郵箱',
    'form.email.invalid': '郵箱格式不正確',
    'form.password': '密碼',
    'form.password.required': '請輸入密碼',
    'form.role': '角色',
    'form.role.required': '請選擇角色',
    'permissions.dashboard': '儀表盤',
    'permissions.members': '會員管理',
    'permissions.members.view': '查看會員',
    'permissions.members.create': '創建會員',
    'permissions.members.edit': '編輯會員',
    'permissions.members.delete': '刪除會員',
    'permissions.members.export': '導出會員',
    'permissions.cards': '禮品卡管理',
    'permissions.cards.view': '查看禮品卡',
    'permissions.cards.create': '創建禮品卡',
    'permissions.cards.edit': '編輯禮品卡',
    'permissions.cards.delete': '刪除禮品卡',
    'permissions.cards.export': '導出禮品卡',
    'permissions.vouchers': '代金券管理',
    'permissions.vouchers.view': '查看代金券',
    'permissions.vouchers.create': '創建代金券',
    'permissions.vouchers.edit': '編輯代金券',
    'permissions.vouchers.delete': '刪除代金券',
    'permissions.vouchers.export': '導出代金券',
    'permissions.settings': '設置',
    'permissions.staff': '員工管理',
    'permissions.selectAll': '全選',
    'permissions.hint': '選擇主模塊會自動選擇其所有子權限',
    'permissions.fetchFailed': '獲取權限數據失敗',
  },
  'pages.store.physicalCard': {
    'title': '實體會員卡',
    'download': '下載實體會員卡',
    'description': '請先聯繫POS供應商獲取會員卡資源。',
    'usage': '點擊下載按鈕可以獲取所有未激活的實體卡的Online Member ID列表，格式為CSV文件。文件將包含所有未激活實體卡的線上會員編號。',
    'downloadSuccess': '實體會員卡文件下載成功',
    'downloadError': '下載實體會員卡失敗',
    'noPermission': '您沒有下載權限',
    'noDataFound': '未找到未激活的實體卡',
  },
  'pages.store.customerExport': {
    'title': '導出用戶',
    'download': '導出用戶',
    'description': '導出所選時間範圍內在客戶歷史記錄中有過記錄的用戶。',
    'timeRange': '時間範圍',
    'status': '狀態',
    'statusActive': '活躍',
    'statusAll': '全部',
    'memberLevel': '會員等級',
    'allMemberLevels': '全部會員等級',
    'oneMonth': '最近1個月',
    'threeMonths': '最近3個月',
    'sixMonths': '最近半年',
    'twelveMonths': '最近1年',
    'success': '用戶列表導出成功',
    'error': '用戶列表導出失敗',
    'noPermission': '您沒有導出權限',
  },
  'pages.store.otherSettings': {
    'title': '其他設置',
    'customerRegisterEmailRequired': '客戶註冊郵箱必填',
    'customerRegisterEmailRequired.description': '啟用後，客戶註冊時必須提供郵箱地址',
    'save.success': '設置保存成功',
    'save.error': '設置保存失敗',
  },
  'pages.pointsAudit.title': '積分審查',
  'pages.pointsAudit.dateRange': '日期範圍',
  'pages.pointsAudit.get': '獲取',
  'pages.pointsAudit.time': '時間',
  'pages.pointsAudit.member': '會員',
  'pages.pointsAudit.currentPoints': '會員當前積分',
  'pages.pointsAudit.pointsChange': '修改積分',
  'pages.pointsAudit.operator': '操作人員',
  'pages.pointsAudit.actions': '操作',
  'pages.pointsAudit.details': '詳情',
  'pages.pointsAudit.total': '共 {total} 條',
  'pages.pointsAudit.loadFailed': '獲取積分審查記錄失敗',
  'pages.pointsAudit.dateRequired': '請選擇日期範圍',
};
